import Parse from 'parse'
import {ParseDbService, cdLinkSchema as Schema, cdLinkCategorySchema as CdLinkCategorySchema} from "./parse.db.service";

function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.CdLinkClassName);
    if (pagination) {
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }
    query.withCount(true);

    query.include(Schema.category);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.name, search);
    }

    return query.find().then(items => {
        return {
            results: items.results.map(item => {
                return {
                    parseItem: item,
                    name: item.get(Schema.name),
                    link: item.get(Schema.link),
                    category: {
                        name: item.get(Schema.category).get(CdLinkCategorySchema.name),
                        parseItem: item.get(Schema.category)
                    },
                }
            }),
            count: items.count
        }
    });
}


function add(item) {
    let ClassItem = Parse.Object.extend(ParseDbService.CdLinkClassName, null, null);
    let classObj = new ClassItem();
    classObj.set(Schema.name, item.name.toLowerCase());
    classObj.set(Schema.link, item.link);
    console.log(item.category);

    classObj.set(Schema.category, item.category.parseItem);
    return classObj.save();
}

function edit(item) {
    let classObj = item.parseItem;
    classObj.set(Schema.name, item.name.toLowerCase());
    classObj.set(Schema.link, item.link);
    classObj.set(Schema.category, item.category.parseItem);
    return classObj.save();
}

export const CdLinkService = {
    getAll,
    add,
    edit
};

